import { BulkActionRef } from 'pbts/c1/api/bulkaction/v1/bulkaction'
import { BulkActionServiceClient } from 'pbts/c1/api/bulkaction/v1/bulkaction.client'

import { createUnaryApi } from 'redux_toolkit/lib/createUnaryApi'
import { createMutationApi } from './lib/createMutationApi'

export const createBulkActionApi = createMutationApi(
    BulkActionServiceClient,
    'createBulkAction',
)

export const getBulkActionApi = createUnaryApi(
    BulkActionServiceClient,
    'getBulkAction',
    undefined,
    BulkActionRef.typeName,
)
